import { Component, Input } from '@angular/core';

export type Breadcrumb = {
  title: string;
  link?: string;
  openInNewWindow?: boolean;
  routeLink?: string | any[];
};

@Component({
  selector: 'vtab',
  templateUrl: './vtab.component.html',
  styleUrls: ['./vtab.component.scss'],
  standalone: false,
})

export class VTabComponent {
  @Input()
  pageTitle: string | null = null;
  @Input() pageItemTitle: string | null = null;
  @Input() pageItemTitles: Breadcrumb[] = [];
  @Input()
  id = '';

  @Input()
  description: string | null = null;

  @Input()
  icon: string | null = null;

  @Input()
  visible = true;

  @Input()
  active = false;
}
